import EllipseStatus from 'common/feedback/EllipseStatus';
import { getPortalAccessVariant } from 'components/Employees/utils';
import { ComponentProps } from 'components/VirtualizedTable/types';
import { Employee } from 'generated/models';
import { I18nProps, withTranslations } from 'i18n';

interface UserRoleCellProps extends ComponentProps<Employee, string, boolean>, I18nProps {}

const UserRoleCell = ({
  extra: showUserRole,
  row: { portalAccessStatus, role },
  t,
}: UserRoleCellProps) => (
  <EllipseStatus variant={getPortalAccessVariant(portalAccessStatus)}>
    {showUserRole ? (
      role ? (
        t(`ngm_access_roles.ngmAccessRoles.${role}`, role)
      ) : (
        <>&mdash;</>
      )
    ) : (
      <></>
    )}
  </EllipseStatus>
);

export default withTranslations(UserRoleCell);
